<template>
    <div class="root">


        <div class="modal criticalmodal" v-if=" showDoubleBarcode" style="z-index: 1000;">
            <transition name="fade">
            <div class="modal-window visible" :class="{ 'visible' : modalid == 1, 'hidden': modalid !== 1 }" v-if="modalid == 1">
                <div class="modal-content">

                    <table style="font-size: 30pt">
                        <td>
                            Der Barcode <span class="barcodespan">{{ fpos.barcode }}</span> wurde bereits eingescannt.<br/><br/>
                            <b>Position:</b> {{ fpos.name }}
                        </td>
                    </table>
                </div>
            </div>
            </transition>
        </div>

        <div class="modal criticalmodal" v-if="invalidBarcode" style="z-index: 1000;">
            <transition name="fade">
            <div class="modal-window visible">
                <div class="modal-content" style="font-size: 30pt; text-align: center;">
                    Dieser Barcode kann leider nicht gelesen werden.
                </div>
            </div>
            </transition>
        </div>


        <div class="modal" v-if="tmptext" style="z-index: 1000;">
            <transition name="fade">
            <div class="modal-window visible" :class="{ 'visible' : modalid == 1, 'hidden': modalid !== 1 }" v-if="modalid == 1">
                <div class="modal-content">
                    <table style="font-size: 30pt">
                        <tr>
                            <td><b>Barcode:</b></td>
                            <td>{{ tmptext.barcode }}</td>
                        </tr>
                        <tr>
                            <td><b>Position:</b></td>
                            <td>{{ tmptext.fpos }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            </transition>
        </div>

        <div class="modal" v-if="showmodal">
            <transition name="fade">
            <div class="modal-window visible" :class="{ 'visible' : modalid == 1, 'hidden': modalid !== 1 }" v-if="modalid == 1">
                <div class="modal-title">
                    {{ translation.BRANDING }}
                </div>
                <div class="modal-content">
                    {{ translation.STR_WELLS_INSERTED }}
                </div>
                <div class="buttons">
                    <div class="btn-yes" v-on:click="StartTest96">{{ translation.STR_YES }}</div>
                    <div class="btn-no" v-on:click="restartApp">{{ translation.STR_NO }}</div>
                </div>
            </div>

            <div class="modal-window visible" :class="{ 'visible' : modalid == 1, 'hidden': modalid !== 33 }" v-if="modalid == 33">
                <div class="modal-title">
                    {{ translation.BRANDING }}
                </div>
                <div class="modal-content">
                    Bitte warten.
                </div>
            </div>



            </transition>
            <transition name="fade">
            <div class="modal-window visible" :class="{ 'visible' : modalid == 2, 'hidden': modalid !== 2 }" v-if="modalid == 2">
                <div class="modal-title">
                    {{ translation.BRANDING }}
                </div>
                <div class="modal-content">
                    {{ translation.STR_LID_CLOSED }}
                </div>
                <div class="buttons">
                    <div class="btn-yes" v-on:click="startRealTest">{{ translation.STR_YES }}</div>
                </div>
            </div>
            </transition>





        </div>
            </transition>

        <section>
            <h1>{{ translation.STR_PLEASE_SCAN_SAMPLES }}</h1>
        </section>
        <section class="wells">
            <table border="1" style="width: 800px; text-align: center; border: 1px solid var(--primary-color);">
                <tr v-for="i in rows">
                    <td v-for="c in layout.filter(e => e.row == i)" :class=" { 'expressprobe': c.express, 'activecell' : (currentrow+1) == i  && c.cell == (currentwell+1), 'inactiverow' : c.cell !== currentwell+1, 'activerow' : c.cell == currentwell+1, 'usedwell' : c.barcode, 'freewell' : !c.barcode  }" v-bind:key="c.name">
                        {{ c.name }}
                    </td>
                </tr>
            </table>
        </section>
        
        <section class="scanner">
            <table style="margin: auto:">
                <tr>
                    <td colspan="2"><span v-if=" tmpcode"><b>Letzer Barcode: </b><b style="font: 12pt 'Courier New';">{{ tmpcode }}</b></span>&nbsp;</td>
                </tr>
                <tr>
                    <td v-if="layout.filter(e => e.barcode == null).length > 0">
                        <input type="text" :disabled="layout.filter(e => e.barcode == null).length == 0" class="barcode" v-on:keyup.enter="AddBarcode" v-model="barcode" :placeHolder="translation.STR_BARCODE" ref="barcodescanner" autofocus />
                    </td>
                    <td v-if="!layout.filter(e => e.barcode == null).length > 0">
                        <div class="error">
                        Es stehen keine weiteren Positionen zur Verfügung.
                        </div>    
                    </td>
                    <td width="200">
                        <input type="button" v-on:click="startTest"  autofocus :disabled="layout.filter(e => e.barcode == null).length > 88" :class="{ 'disabledbtn' : layout.filter(e => e.barcode == null).length > 88}" :value="translation.STR_START" />
                    </td>
                    <td v-if="ScreeningPortalEnabled && layout.filter(e => e.barcode == null).length">
                        <div class="express-probe" :class="{ 'expresson':epxressprobeenabled, 'expressoff': !epxressprobeenabled }" v-on:click="epxressprobeenabled=!epxressprobeenabled">
                            Express: <b>{{ epxressprobeenabled ? "EIN" : "AUS" }}</b>
                        </div>
                    </td>                    
                </tr>
            </table>

            <button class="testbutton" v-on:click="addTestProbes()" v-if="customer.id == 'd4de68c7-b98a-4ac3-a014-f59f6fd4de4b'">Testproben hinzufügen</button>
            
            
        </section>


    </div>
</template>
<script>
var timer_tmpcode = null;
export default ({
    props: [ 'translation', 'ScreeningPortalEnabled', 'customer'],
    mounted() {
        this.calcWells()
        this.OpenLID();
        setInterval(() => {
            this.$refs.barcodescanner.focus();
        }, 500);        
    },
    methods: {
        addTestProbes() {
            for (let i = 0; i < 8; i++) {
                this.barcode = "R000"+i;
                this.AddBarcode();
            }
            this.StartTest96();
        },
        OpenLID() {
            this.axios.get("http://127.0.0.1:8441/procomcure/?cmd=openlid").catch(() => {
                this.$emit('triggererror', 'Opening Lid did not work.')
            })
        },
        StartTest96() {
            this.showmodal = false;
            this.OpenLID();
            this.showmodal=1;
            this.modalid = 33;
            setTimeout(() => {
                this.startRealTest();
            }, 25000);
        },
        startTest() {
            this.showmodal = true;
            this.modalid = 1;
        },
        restartApp() {
            this.showmodal = false;
            this.modalid = 1;
        },
        startRealTest() {
            this.$router.push({
                name: 'StartTest',
                params: {
                    test: this.$route.params.testType,
                    wells: this.layout,
                    dev: 96,
                }
            })
        },
        AddBarcode() {
            var barcode = this.barcode;


            var barcode_used = this.layout.find(e => e.barcode == barcode)
            if(barcode_used) {
                this.showDoubleBarcode = true;
                this.barcode = null;
                this.modalid = 1;
                this.fpos = barcode_used;
                setTimeout(() => {
                    this.showDoubleBarcode = false;
                }, 3000)
                return false;
            }

            if(barcode.length == 10 || barcode.substring(0,1) == "R" || barcode.substring(barcode.length-3) == "TPC" || barcode.substring(barcode.length-3) == "NTC") {
                this.barcode = null;
                this.tmpcode = barcode;
                setTimeout(() => {
                    this.tmpcode =null;
                }, 800)
                var current_well = this.layout.find(e => e.row == (this.currentrow+1) && e.cell == (this.currentwell+1));
                if(current_well) {
                    current_well.barcode = barcode;
                    current_well.express = this.epxressprobeenabled;
                }

                if(this.currentrow == 7) { this.currentrow = -1; this.currentwell++; }
                this.currentrow++;
            } else {
                this.barcode = null;
                this.invalidBarcode = true;
                setTimeout(() => {
                    this.invalidBarcode = false;
                }, 3000)
            }
        },


        calcWells() {
            var layout = [];
            for (let row = 1; row < 9; row++) {
                for (let line = 1; line < 13; line++) {
                    var line_name = line < 10 ? "0"+line : line;
                    layout.push({
                        row: row,
                        cell: line,
                        name: this.getRowFriendlyName(row)+line_name,
                        fpos: this.getRowFriendlyName(row)+line_name,
                        barcode: null,
                        express: false,
                    })
                }    
            }
            this.layout = layout;
        },
        getRowFriendlyName(a) {
            if(a == 1) return "A";
            if(a == 2) return "B";
            if(a == 3) return "C";
            if(a == 4) return "D";
            if(a == 5) return "E";
            if(a == 6) return "F";
            if(a == 7) return "G";
            if(a == 8) return "H";
            if(a == 9) return "I";
            if(a == 10) return "J";
            if(a == 11) return "K";
        },
        startTest() {
            this.showmodal = true;
        },
        restartApp() {
            this.showmodal = false;
            this.modalid = 1;
        },
        startTest2() {
            this.modalid = 2;
        },
  },
    data() { 
        return {
            epxressprobeenabled: false,
            layout: [],
            showmodal: false,
             showDoubleBarcode: false,
            tmptext: false,
            rows: 8,
            lines: 13,
            currentrow: 0,
            currentwell: 0,
            barcode: null,
             tmpcode: null,
            invalidBarcode: null,
            modalid: 1,
            fpos: null,
        } 
    }
})
</script>
<style scoped>
.root {
    height: 100%;
    width: 100%;
}
table {
    width: 500px;
    margin: auto;
}
.wells {
    height: 500px;
    display: flex;
    justify-content: center;
    align-content: center;
}
.wells div {
    margin: auto;
}
.scanner {
    height: 120px;
    width: 100%;
    display: flex;
}
.scanner input[type="text"] {
    padding: 25px;
    width: 500px;
    border: 1px solid var(--primary-color);
    border-radius: 0px;
    margin: auto;
}

.scanner input[type="button"] {
    padding: 25px;
    width: 150px;
    border: 1px solid var(--primary-color);
    border-radius: 0px;
    margin: auto;
    cursor: pointer;
    background-color: var(--primary-color);
    color: var(--secondary-color);
}

.freewell {
    background-color: lightgreen !important;
}

.usedwell {
    background-color: var(--primary-color) !important;
    filter: blur(4px);
}

.scanner input:focus {
    outline: none;
}

.avail {
    background-color: lightgreen !important;
}
.inuse {
    background-color: var(--primary-color) !important;
    color: var(--secondary-color);
}

.dot {
  height: 80px;
  width: 80px;
  background-color: #bbb;
  border-radius: 50%;
  display: flex;
  justify-content: center;
}
.dot span {
    margin: auto;
}
.disabledbtn {
    background-color: gray !important;
    color: silver !important;
}
.mostcriticalmodal {
    background-color: red !important;
}
.criticalmodal {
    background-color: black !important;
    background-size: cover;
    color: #fff;

    -webkit-animation: AnimationName 0s ease infinite;
    -moz-animation: AnimationName 0s ease infinite;
    animation: AnimationName 0s ease infinite;

}
.criticalmodal .modal-content {
    background-color: black;
}
.modal {
    position: absolute;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 100%;
    background-color: var(--primary-color);
    display: flex;
}
.modal-window {
    position: absolute;
    min-width: 400px;
    margin: auto;
    border: 1px solid var(--secondary-color);
    background-color: var(--secondary-color);


    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.modal-title {
    padding: 15px;
    font-weight: bold;
    border-bottom: 2px solid var(--primary-color);
}
.modal-content {
    padding: 15px;
}
.modal .buttons {
    padding: 15px;
    display: flex;
    text-align: center;
    align-items: center;
    width: 320px;
    margin: auto;
}
.btn-yes {
    background-color: var(--primary-color);
    color: var(--secondary-color);
    padding: 15px;
    width: 150px;
    text-align: center;
    margin-right: 10px;
    cursor: pointer;
}
.btn-no {
    background-color: var(--primary-color);
    color: var(--secondary-color);
    padding: 15px;
    width: 150px;
    text-align: center;
    margin-right: 10px;
    cursor: pointer;
}

.tmpcode {
    font: 10pt "courier new";
    position: absolute;
    bottom: 280px;
    font-size: 18pt;
    font-weight: bold;
    background-color: lightblue;
    padding: 15px;
    width: 200px;
    margin: auto;
}

.error {
    background-color: pink;
    font-size: 13pt;;
    padding: 15px;
}

.barcodespan {
    background-color: black;
    color: #fff;
    padding-left: 5px;
    padding-right: 5px;
    font-face: 'Courier New';
}



@-webkit-keyframes AnimationName {
    0%{background-position:0% 50%}
    50%{background-position:100% 51%}
    100%{background-position:0% 50%}
}
@-moz-keyframes AnimationName {
    0%{background-position:0% 50%}
    50%{background-position:100% 51%}
    100%{background-position:0% 50%}
}
@keyframes AnimationName {
    0%{background-position:0% 50%}
    50%{background-position:100% 51%}
    100%{background-position:0% 50%}
}

.activerow {
    background-color: lightgreen;
    color: #fff;
    border: 1px solid #fff;
}

.inactiverow {
    background-color: gray;
    filter: blur(4px);
    color: #fff;
    border: 1px solid #fff;
}
.activecell {
    background-color: red;
}



@keyframes color {
  0% {
    background-color: red;
  }
  50% {
    background-color: red;
  }
  100 {
    background-color: red;
  }
}

.modal {
    z-index: 1000;
}

.express-probe {
    top: 10px;
    left: calc(100% - 180px);
    padding: 10px;
    width: 120px;
    cursor: pointer;
    box-sizing: border-box;
}
.expressprobe {
    outline: 3px solid gold;
    background-color: gold !important;
    color: black !important;
}
.expresson {
    background-color: lightgreen;
    color: black;
}
.expressoff {
    background-color: red;
}
.testbutton {
    border: 15px solid red;
    cursor: pointer;
    outline: 15px solid gold;
    font-weight: bold;
    position: relative;
    top: -350px;
    left: -500px;
}
.testbutton:hover {
    background-color: black;
    color: #fff;
}
</style>